import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Link } from '@digdir/designsystemet-react';
import { useGetWorkEnvironmentSurveyByIdQuery } from '../../hooks/queries/useGetWorkEnvironmentSurveyByIdQuery';
import { useSurveyPaths } from '../../hooks/useSurveyPaths';
import { planAreaPath } from '../WorkEnvironmentSurveyDetail/surveyRoutes';
import { TeamInspectionReport } from './TeamInspectionReport';

/** The inspection report of a team on a page of its own, to read, print or save as PDF */
export const WorkEnvironmentInspectionReportPage = (): ReactElement => {
  const { t } = useTranslation();
  const surveyId = Number(useParams<{ surveyId: string }>().surveyId);
  const paths = useSurveyPaths();
  const { data: survey } = useGetWorkEnvironmentSurveyByIdQuery(surveyId, { enabled: Boolean(surveyId) });
  // What remains links to the plan step for those who make plans
  const makesPlans = Boolean(survey?.actions?.includes('makePlan'));
  return (
    <TeamInspectionReport
      surveyId={surveyId}
      planLink={makesPlans ? (areaKey) => planAreaPath(paths.section, surveyId, areaKey) : undefined}
      back={
        <Link asChild data-size="sm">
          <RouterLink to={paths.survey(surveyId)}>{t('workEnvironmentInspection.toolbar.back')}</RouterLink>
        </Link>
      }
    />
  );
};
